module.exports = __webpack_public_path__ + "2aed9749f890de53400dcbc322a3bccd.svg";